import React from 'react'

const FormRow = ({ children, last, ...props }) => (
  <div className={last ? "mb-8 lg:mb-10" : "mb-5 lg:mb-8"} {...props}>
    { children }
  </div>
)

export { FormRow }
